import { BaseProduct, ProductBuilderMachineContext } from '../types';

type GetDesignerTape = (context: ProductBuilderMachineContext) => string[];
type ProductHasDesignerTapeOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForDesignerTape = (
  product: BaseProduct,
) => DesignerTapeKey | null;

type DesignerTapeKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithDesignerTape = (
  designerTape: string,
) => (product: BaseProduct) => boolean;

export const productHasDesignerTapeOption: ProductHasDesignerTapeOption = product =>
  product.options.includes('Designer Tape');

export const getVariantOptionKeyForDesignerTape: GetVariantOptionKeyForDesignerTape = product => {
  const designerTapeIndex = product.options.findIndex(
    option => option === 'Designer Tape',
  );
  if (designerTapeIndex === -1) return null;

  return `option${designerTapeIndex + 1}` as DesignerTapeKey;
};

export const getDesignerTape: GetDesignerTape = context => {
  const { products } = context;

  const designerTapeKey =
    products.length > 0
      ? getVariantOptionKeyForDesignerTape(products[0])
      : null;
  if (designerTapeKey === null) return [];

  return Array.from(
    new Set(
      products
        .map(({ variants }) =>
          variants.map(variant => {
            return variant[designerTapeKey] as string;
          }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithDesignerTape: ProductHasVariantWithDesignerTape = designerTape => product => {
  const optionKey = getVariantOptionKeyForDesignerTape(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === designerTape);
};
